<template>
  <v-container
    d-flex
    align-content-center
    fill-height
    fluid
    style="height: 100vh"
    class="pt-0"
  >
    <v-row justify="center">
      <v-col cols="12" sm="12" md="auto" class="pa-4" style="max-width: 100%">
        <ingestor-add
          :mode="mode"
          :ingestor="ingestor"
          @confirm="$emit('close')"
          @cancel="$emit('close')"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import IngestorAdd from './Overlay/IngestorAdd.vue';

export default {
  components: {
    IngestorAdd,
  },
  props: {
    mode: {
      type: String,
      default: '',
    },
    ingestor: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  computed: {},
};
</script>

<style></style>
